import { css } from 'lit';

export const sharedStyles = css`
  input {
    padding: 7px;
    width: calc(100% - 18px);
    border-radius: 5px;
    font-size: 16px;
  }

  input:read-only {
    background-color: #014e2a;
    color: white;
  }

  .fill {
    flex-grow: 1;
  }

  .column {
    display: flex;
    flex-direction: column;
    padding-left: 10px;
    padding-right: 10px;
  }

  svg:hover {
    cursor: pointer;
  }

  .table-column {
    padding-top: 12px;
    padding-bottom: 12px;
    overflow-wrap: break-word;
  }

  .table-row:hover {
    background-color: var(--background-color-hover);
    cursor: pointer;
  }
`;
